import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../service/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isLoggedIn = authService.isAuthenticated();
  if (!isLoggedIn) {
    router.navigate(['/auth/login']);
  }
  return isLoggedIn;
};
